import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Landing from 'modules/partial/Landing';
import { Login } from 'modules/auth';
import Register from 'modules/register';
import ForgotPassword from 'modules/forgot-password';
import ChangePassword from 'modules/forgot-password/change-password';

function Public() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/change-password" component={ChangePassword} />
      <Route path="/" component={Landing} />
    </Switch>
  );
}

Public.propTypes = {};

export default Public;
